import React from "react";

const AddSectionToPageForm = ({
  pages,
  sections,
  selectedPageId,
  setSelectedPageId,
  selectedSectionId,
  setSelectedSectionId,
  pageSectionOrder,
  setPageSectionOrder,
  onSubmit,
}) => {
  return (
    <div className="pb-card">
      <h2>Add Section to Page</h2>
      <form onSubmit={onSubmit}>
        <label className="pb-label">Select Page</label>
        <select
          className="pb-select"
          value={selectedPageId}
          onChange={(e) => setSelectedPageId(e.target.value)}
          required
        >
          <option value="">-- select page --</option>
          {pages.map((p) => (
            <option key={p.id} value={p.id}>
              {p.title}
            </option>
          ))}
        </select>

        <label className="pb-label">Select Section</label>
        <select
          className="pb-select"
          value={selectedSectionId}
          onChange={(e) => setSelectedSectionId(e.target.value)}
          required
        >
          <option value="">-- select section --</option>
          {sections.map((s) => (
            <option key={s.id} value={s.id}>
              {s.title} ({s.mode})
            </option>
          ))}
        </select>

        <label className="pb-label">Order</label>
        <input
          className="pb-input"
          type="number"
          value={pageSectionOrder}
          onChange={(e) => setPageSectionOrder(Number(e.target.value))}
        />

        <button className="pb-button" type="submit">
          Add To Page
        </button>
      </form>
    </div>
  );
};

export default AddSectionToPageForm;